var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:("svg-icon icon-" + _vm.name),attrs:{"aria-hidden":"true"},on:{"click":_vm.onIconClicked}},[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }